export const AlarmBell = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 12.1267L13.5 11.6267L13 11.12C12.8666 10.9866 12.7542 10.8337 12.6667 10.6667V6.53999C12.6529 5.47776 12.2703 4.45335 11.5844 3.64215C10.8984 2.83096 9.95184 2.28343 8.90667 2.09333C8.97757 1.94094 9.00892 1.77314 8.99782 1.60544C8.98672 1.43773 8.93353 1.27553 8.84316 1.13382C8.7528 0.992108 8.62817 0.875459 8.4808 0.794649C8.33343 0.71384 8.16807 0.671478 8 0.671478C7.83193 0.671478 7.66657 0.71384 7.5192 0.794649C7.37183 0.875459 7.2472 0.992108 7.15684 1.13382C7.06647 1.27553 7.01328 1.43773 7.00218 1.60544C6.99108 1.77314 7.02243 1.94094 7.09333 2.09333C6.04816 2.28343 5.10157 2.83096 4.41564 3.64215C3.72972 4.45335 3.34711 5.47776 3.33333 6.53999V10.6667C3.24577 10.8337 3.13338 10.9866 3 11.12L2.5 11.6267L2 12.1267V14.0533H6.66667C6.66667 14.4069 6.80714 14.7461 7.05719 14.9961C7.30724 15.2462 7.64638 15.3867 8 15.3867C8.35362 15.3867 8.69276 15.2462 8.94281 14.9961C9.19286 14.7461 9.33333 14.4069 9.33333 14.0533H14V12.1267Z"
      fill="#696969"
    />
  </svg>
);
